import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api, errorMessage } from "@/lib/api";
import { AuthShell } from "./AuthShell";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const { user, reload } = useAuth();
  const [status, setStatus] = useState("working");
  const [error, setError] = useState("");
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const token = params.get("token");
    if (!token) { setStatus("error"); setError("This link is missing its code. Please use the link from your email."); return; }
    api.post("/auth/verify-email", { token })
      .then(() => { setStatus("ok"); reload(); })
      .catch((e) => { setStatus("error"); setError(errorMessage(e)); });
  }, [params, reload]);

  const next = user ? "/app" : "/signin";
  return (
    <AuthShell eyebrow="Email confirmation" title={status === "ok" ? "Your email is confirmed" : status === "error" ? "We couldn't confirm your email" : "Confirming your email..."}>
      <div data-testid="verify-email-panel" className="space-y-6">
        {status === "ok" && (
          <div data-testid="verify-email-success" className="flex gap-3 rounded-md border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-900">
            <CheckCircle2 className="h-5 w-5 shrink-0" /> <p>Thanks. You can now set up your homeowner or agent workspace and add your first property.</p>
          </div>
        )}
        {status === "error" && (
          <div data-testid="verify-email-error" className="flex gap-3 rounded-md border border-red-200 bg-red-50 p-4 text-sm text-red-800">
            <XCircle className="h-5 w-5 shrink-0" /> <p>{error}</p>
          </div>
        )}
        {status !== "working" && (
          <Link to={status === "ok" ? next : user ? "/check-email" : "/signin"} data-testid="verify-email-continue-link"
            className="inline-flex h-11 items-center rounded-md bg-navy px-6 text-sm font-medium text-white transition-colors hover:bg-navy-2">
            {status === "ok" ? (user ? "Go to my dashboard" : "Sign in") : user ? "Request a new link" : "Sign in to request a new link"}
          </Link>
        )}
      </div>
    </AuthShell>
  );
}
